import request from '@/utils/seftRequest';

export function frServiceInfoCheck(params) {
  return request('/ding/channel/frServiceInfoCheck', {
    params
  });
}